import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import nProgress from 'nprogress';

// Drives nProgress's "navigation in flight" bar from React Router's
// location changes. Replaces the Next-Pages-router pattern that
// subscribed to `Router.events.on('routeChangeStart', ...)`.
//
// React Router doesn't have a discrete "navigation started" event —
// `useLocation()` fires when the new location is already applied. The
// approximation here: when location changes, briefly start + finish
// nProgress on the same tick so the user sees the bar flash. For a
// truly "anticipatory" indicator (Next's start-before-render) we'd
// need a router-aware fetcher; deferred until anyone misses it.
export function useNProgress() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const firstRenderRef = useRef(true);

  useEffect(() => {
    // Suppress the bar on initial mount — only subsequent navigations
    // should trigger it. `useNavigationType` lets us differentiate
    // "POP" (back/forward) from "PUSH" / "REPLACE" but for the visual
    // we treat them all the same.
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return undefined;
    }
    nProgress.start();
    // Finish on the next microtask so the bar at least flashes.
    // For a slower visible flash, swap setTimeout(..., 150).
    const handle = window.setTimeout(() => nProgress.done(), 0);
    return () => window.clearTimeout(handle);
  }, [location.key, navigationType]);
}
